const Menus = 
 [
  {
    "id": 1,
    "name": "Pizza",
    "subtitle": "Speciality Pizzas",
    "meals": [
      {
        "id": 1.1,
        "name": "The Cheeseburger",
        "kcal": [
          "698",
          "1016",
          "1763",
          "2363",
        ],
        "serves": "3-4",
        "sizes": [
          "Personal 7'' £11.99",
          "Small 9.5'' £19.99",
          "Medium 11.5'' £21.99",
          "Large 13.5'' £23.99"
        ],
        "image": require("./images/pizzas/speciality-pizza/cheeseburger.webp")
      },
      {
        "id": 1.2,
        "name": "Original Cheese & Tomato",
        "kcal": [
          "598",
          "996",
          "1543",
          "2223"
        ],
        "serves": "3-4",
        "sizes": [
           "Personal 7'' £8.99",
          "Small 9.5'' £14.99",
          "Medium 11.5'' £17.99",
          "Large 13.5'' £19.99"
        ],
        "image": require("./images/pizzas/speciality-pizza/cheese-tomato.webp")
      },
      {
        "id": 1.3,
        "name": "Vegi Supreme",
        "kcal": [
          "598",
          "816",
          "1563",
          "2003",
        ],
        "serves": "3-4",
        "sizes": [
          "Personal 7'' £10.99",
          "Small 9.5'' £18.99"   ,
          "Medium 11.5'' £20.99",
          "Large 13.5'' £22.99"
        ],
        "image": require("./images/pizzas/speciality-pizza/vegi-supreme.webp")
      },
      {
        "id": 1.4,
        "name": "Hot & Spicy",
        "kcal": [
          "788",
          "1006",
          "1363",
          "2253"
        ],
        "serves": "3-4",
        "sizes": [
           "Personal 7'' £9.99",
          "Small 9.5'' £17.99"   ,
          "Medium 11.5'' £19.99",
          "Large 13.5'' £21.99"
        ],
        "image": require("./images/pizzas/speciality-pizza/hot-spicy.webp")
      },
      {
        "id": 1.5,
        "name": "The Meatfielder",
        "kcal": [
          "698",
          "1016",
          "1763",
          "2363"
        ],
        "serves": "3-4",
        "sizes": [
          "Personal 7'' £10.99",
          "Small 9.5'' £18.99"   ,
          "Medium 11.5'' £20.99",
          "Large 13.5'' £22.99"
        ],
        "image": require("./images/pizzas/speciality-pizza/meatfielder.webp")
      },
      {
        "id": 1.6,
        "name": "American Hot",
        "kcal": [
          "708",
          "1096",
          "1763",
          "2373"
        ],
        "serves": "3-4",
        "sizes": [
          "Personal 7'' £9.99",
          "Small 9.5'' £17.99"   ,
          "Medium 11.5'' £19.99",
          "Large 13.5'' £21.99"
        ],
        "image": require("./images/pizzas/speciality-pizza/american-hot.webp")
      }
    ]
  },
  {
    "id": 2,
    "subtitle": "Gluten Free",
    "meals": [
      {
        "id": 2.1,
        "name": "Gluten Free New Yorker",
        "kcal": [829],
        "serves": "1-2",
        "sizes": [
          "Small 9.5'' £18.99"  
        ],
        "image": require("./images/pizzas/gluten-free-pizza/gf-new-yorker.webp")
      },
      {
        "id": 2.2,
        "name": "Gluten Free Pepperoni",
        "kcal": [953],
        "serves": "1-2",
        "sizes": [
          "Small 9.5'' £18.99"  
        ],
        "image": require("./images/pizzas/gluten-free-pizza/gf-pepperoni.webp")
      },
      {
        "id": 3.3,
        "name": "Gluten Free Four Cheeses",
        "kcal": [677],
        "serves": "1-2",
        "sizes": [
          "Small 9.5'' £13.99"  
        ],
        "image": require("./images/pizzas/gluten-free-pizza/gf-tomato-cheese.webp")
      },
      {
        "id": 4.4,
        "name": "Gluten Free Vegi Supreme",
        "kcal": [685],
        "serves": "1-2",
        "sizes": [
          "Small 9.5'' £18.99"  
        ],
        "image": require("./images/pizzas/gluten-free-pizza/gf-vegi.webp")
      }      
    ]
  },
  {
    "id": 3,
    "name": "FANCY A BIT ON THE SIDE?",
    "meals": [
      {
        "id": 3.1,
        "name": "Loaded Wedges-Cheese",
        "kcal": [543],
        "serves": "2",
        "price": 6.99,
        "image": require("./images/sides/wedges-cheese.webp")
      },    
      {
        "id": 3.2,
        "name": "Garlic Dippers",
        "kcal": [243],
        "serves": "2",
        "price": 5.99,
        "image": require("./images/sides/garlic-dippers.webp")
      },
      {
        "id": 3.3,
        "name": "Vegan Nuggets",
        "kcal": [399],
        "serves": "2",
        "price": 8.99,
        "image": require("./images/sides/vegan-nuggets.webp")
      },
      {
        "id": 3.4,
        "name": "Garlic Pizza Bread",
        "kcal": [614],
        "serves": "2",
        "price": 5.99,
        "image": require("./images/sides/garlic-pizza-bread.webp")
      },
      {
        "id": 3.5,
        "name": "Wedges & Spicy Sausage",
        "kcal": [764],
        "serves": "2",
        "price": 6.99,
        "image": require("./images/sides/wedges-spicy-sausage.webp")
      },
      {
        "id": 3.6,
        "name": "Chicken Wings",
        "kcal": [324],
        "serves": "2",
        "price": 7.99,
        "image": require("./images/sides/chicken-wings.webp")
      }
    ],
  },
    {
    "id": 4,
    "name": "Sweeten the deal",
    "meals": [
      {
        "id": 4.1,
        "name": "Cookies",
        "kcal": [694],
        "serves": "4",
        "price": 5.99,
        "image": require("./images/desserts/cookies.webp")
      },
      {
        "id": 4.2,
        "name": "Chocca Pizza",
        "kcal": [822],
        "serves": "4",
        "price": 5.99,
        "image": require("./images/desserts/chocca-pizza.webp")
      },
      {
        "id": 4.3,
        "name": "Cinni Dippers",
        "kcal": [198],
        "serves": "4",
        "price": 5.99,
        "image": require("./images/desserts/cinni-dippers.webp")
      },
      {
        "id": 4.4,
        "name": "Caramel Chew Chew-465ml",
        "kcal": [843],
        "serves": "4",
        "price": 6.99,
        "image": require("./images/desserts/caramel-chew-chew.webp")
      },
      {
        "id": 4.5,
        "name": "Chocolate Fudge Browniw-465ml",
        "kcal": [820],
        "serves": "4",
        "price": 6.99,
        "image": require("./images/desserts/chocolate-fudge-brownie.webp")
      },
      {
        "id": 4.6,
        "name": "Cookie Dough-465ml",
        "kcal": [784],
        "serves": "4",
        "price": 6.99,
        "image": require("./images/desserts/cookie-dough.webp")
      },
      {
        "id": 4.7,
        "name": "Phish Food-465ml",
        "kcal": [836],
        "serves": "4",
        "price": 6.99,
        "image": require("./images/desserts/phish-food.webp")
      },
    ]},
    {
      "id": 5,
      "name": "Thirst Quenchers",
      "meals": [
        {
          "id": 5.1,
          "name": "Glaceau Smartwater-600ml",
          "kcal": [0],
          "price": 1.39,
          "image": require("./images/drinks/smartwater-still.webp")
        },
        {
          "id": 5.2,
          "name": "Fanta-500ml",
          "kcal": [364],
          "price": 1.99,
          "image": require("./images/drinks/fanta.webp")
        },
        {
          "id": 5.3,
          "name": "Sprite-500ml",
          "kcal": [325],
          "price": 1.99,
          "image": require("./images/drinks/sprite.webp")
        },
        {
          "id": 5.4,
          "name": "Coca-Cola-500ml",
          "kcal": [439],
          "price": 1.99,
          "image": require("./images/drinks/coca-cola-classic.webp")
        },
      ]}
]


export default Menus
